var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(-434 -208)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(434 208)",
    fill: "#ed2024",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_30",
    "data-name": "Layer 30",
    transform: "translate(446.908 222.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M10.965,4.128v15.6a2.128,2.128,0,0,1-2.128,2.128H8.128A2.128,2.128,0,0,1,6,19.731V4.128A2.128,2.128,0,0,1,8.128,2h.709A2.128,2.128,0,0,1,10.965,4.128ZM18.057,2h-.709A2.128,2.128,0,0,0,15.22,4.128v15.6a2.128,2.128,0,0,0,2.128,2.128h.709a2.128,2.128,0,0,0,2.128-2.128V4.128A2.128,2.128,0,0,0,18.057,2Z",
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.29daaf059cb91f6b4fafd358921d7959.svg";
export { ForwardRef as ReactComponent };